import React from 'react';
import { Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

/**
 * Shared so every panel that rises from the bottom takes exactly as long as the note composer —
 * the first one to do it. Two dialogs in the same flow moving at different speeds read as two
 * different apps.
 */
export const SLIDE_TIMEOUT = { enter: 260, exit: 200 };

const SlideUpTransition = React.forwardRef(function SlideUpTransition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} timeout={SLIDE_TIMEOUT} {...props} />;
});

export default SlideUpTransition;
